<template>
    <div>
        <Project  :client="client"
                  :product="product"
                  :tasks="tasks"
        />

        <transition appear name="slide-bot">
            <section class="grid-section" id="project-intro">
                <a href="#" v-scroll-to="'.project-content'" class="scroll-arrow">
                    <svg width="10px" height="72px" viewBox="0 0 10 72" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="arrow-down" fill-rule="nonzero">
                            <polygon id="arrow-copy" transform="translate(4.535534, 36.000347) rotate(-270.000000) translate(-4.535534, -36.000347) " points="38.6565072 36.4648132 -31.464119 36.4648132 -31.464119 35.4648132 38.5854393 35.4648132 35.2925461 32.17192 35.9996529 31.4648132 40.5351868 36.0003471 35.9996529 40.535881 35.2925461 39.8287743"></polygon>
                            </g>
                        </g>
                    </svg>
                </a>
                <img id="intro-content" src="@/assets/img/posters/poster-showtime.png">

            </section>
        </transition>
        <section class="project-content">
            <div class="grid-section" id="poster-2">
                <a href="#" v-scroll-to="'#poster-3'" class="scroll-arrow">
                    <svg width="10px" height="72px" viewBox="0 0 10 72" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="arrow-down" fill-rule="nonzero">
                                <polygon id="arrow-copy" transform="translate(4.535534, 36.000347) rotate(-270.000000) translate(-4.535534, -36.000347) " points="38.6565072 36.4648132 -31.464119 36.4648132 -31.464119 35.4648132 38.5854393 35.4648132 35.2925461 32.17192 35.9996529 31.4648132 40.5351868 36.0003471 35.9996529 40.535881 35.2925461 39.8287743"></polygon>
                            </g>
                        </g>
                    </svg>
                </a>
                <img src="@/assets/img/posters/poster-stray.png">
            </div>
            <div class="grid-section" id="poster-3">
                <a href="#" v-scroll-to="'#poster-4'" class="scroll-arrow">
                    <svg width="10px" height="72px" viewBox="0 0 10 72" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="arrow-down" fill-rule="nonzero">
                                <polygon id="arrow-copy" transform="translate(4.535534, 36.000347) rotate(-270.000000) translate(-4.535534, -36.000347) " points="38.6565072 36.4648132 -31.464119 36.4648132 -31.464119 35.4648132 38.5854393 35.4648132 35.2925461 32.17192 35.9996529 31.4648132 40.5351868 36.0003471 35.9996529 40.535881 35.2925461 39.8287743"></polygon>
                            </g>
                        </g>
                    </svg>
                </a>
                <img src="@/assets/img/posters/poster-wakethetown.png">
            </div>
            <div class="grid-section" id="poster-4">
                <a href="#" v-scroll-to="'#poster-5'" class="scroll-arrow">
                    <svg width="10px" height="72px" viewBox="0 0 10 72" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="arrow-down" fill-rule="nonzero">
                                <polygon id="arrow-copy" transform="translate(4.535534, 36.000347) rotate(-270.000000) translate(-4.535534, -36.000347) " points="38.6565072 36.4648132 -31.464119 36.4648132 -31.464119 35.4648132 38.5854393 35.4648132 35.2925461 32.17192 35.9996529 31.4648132 40.5351868 36.0003471 35.9996529 40.535881 35.2925461 39.8287743"></polygon>
                            </g>
                        </g>
                    </svg>
                </a>
                <img src="@/assets/img/posters/poster-bassline.png">
            </div>
            <div class="grid-section" id="poster-5"><img src="@/assets/img/posters/poster-wakethetown2.png"></div>
        </section>
    </div>
</template>

<script>
    import Project from "@/components/Project.vue";
    export default {
        name: "Posters",
        components: {
            Project
        },
        data () {
            return {
                client: "Posters",
                product: "2007 – 2020",
                tasks: {
                    task1: "Art Direction",
                    task2: "Illustration",
                    task3: "Concept & Text",
                },
            }
        }
    };
</script>

<style scoped>
    #project-intro {
        margin-bottom:0;
        background-color: rgba(243,157,150,1);
    }

    #project-intro #intro-content
    {
        grid-column: 2 / 6;
        grid-row: 1 / 7;
        height: 90vh;
        justify-self: center;
    }

    .scroll-arrow {
        grid-column: 1 / 2;
        grid-row: 5 / 6;
        padding-right: 1.4rem;
        padding-left: 1.4rem;
        justify-self: right;
        align-self: end;
    }

    #project-intro .scroll-arrow g {
        fill: rgb(44,37,61);
    }

    .project-content img
    {
        grid-column: 2 / 6;
        grid-row: 1 / 7;
        height: 90vh;
        justify-self: center;
    }

    #poster-2
    {
        margin-bottom: 0;
        background-color: rgba(75,70,107,1);
    }

    #poster-2 g
    {
            fill: rgb(223,227,220);
    }

    #poster-3
    {
        margin-bottom: 0;
        background-color: rgba(120,196,198,1);
    }

    #poster-3 g
    {
        fill: rgb(37,94,107);
    }

    #poster-4
    {
        margin-bottom: 0;
        background-color: rgba(255,241,130,1);
    }

    #poster-4 g
    {
        fill: rgb(32,50,78);
    }

    #poster-5
    {
        margin-bottom: 0;
        background-color: rgba(211,200,187,1);
    }
</style>